//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ROLES from '@/constants/roles'
import QuizProgressList from '@/components/Projects/Detail/Tabs/QuizProgressList.vue'
import Button from '@/components/Shared/Button'
import FilterFormGroup from '@/components/SkillsInventory/Filters/FilterFormGroup'
import FilteredTag from '@/components/SkillsInventory/FilteredTag'
import { mapActions, mapState } from 'vuex'
import { SECTIONS } from '~/constants/questionary'
import { PERMISSION_LABELS } from '~/constants/permission-labels'

export default {
  name: 'QuizProgressTab',
  components: {
    QuizProgressList,
    Button,
    FilterFormGroup,
    FilteredTag,
  },
  props: {
    project: {
      type: Object,
      default: () => ({}),
    },
  },
  async fetch() {
    await this.getEmployeesInProject()
    this.$store.commit('loading', true)
    const [
      { enabled: isEnabledMatchPotential },
      { enabled: isEnabledReassessment },
    ] = await this.$permissions.allow([
      PERMISSION_LABELS.MATCH_POTENTIAL.BASE,
      PERMISSION_LABELS.PROJECTS_REASSESSMENT.BASE,
    ])
    this.isEnabledMatchPotential = !!isEnabledMatchPotential
    this.isEnabledReassessment = Boolean(isEnabledReassessment)
    this.$store.commit('loading', false)
  },
  data: () => ({
    table: {
      filters: {
        _sort: 'created_at:DESC',
        _limit: 10,
        _start: 0,
      },
      filtersPending: {
        _where: { active: true },
      },
      data: [],
      total: 0,
      totalPending: 0,
    },
    showFilters: false,
    filters: {
      names: '',
      currentQuestionary: [],
      modelQuestionary: [],
    },
    selectedFilters: {
      currentQuestionary: [],
      modelQuestionary: [],
    },
    options: {
      status: [
        {
          label: 'Aceptada',
          key: false,
        },
        {
          label: 'Pendiente',
          key: true,
        },
      ],
    },
    isEnabledMatchPotential: false,
    isEnabledReassessment: false,
  }),
  computed: {
    ...mapState({
      employeesInProject: (state) => state.project.employeesInProject,
    }),
    defaultFilter() {
      return {
        'user.role.type': ROLES.EMPLOYEE,
        'user.company': this.$store.state.me.user.company?.id,
      }
    },
    showFiltersTag() {
      return (
        this.selectedFilters.currentQuestionary.length > 0 ||
        this.selectedFilters.modelQuestionary.length > 0
      )
    },
    existsModelQuestionary() {
      return !!this.project.has_models
    },
    existsActiveQuestionary() {
      return !!this.project.main_target_occupation_id
    },
    calculateDataWithFilters() {
      const employees = [...this.employeesInProject]
      const processed = employees.map((item) => ({
        ...item,
        disabled: this.isAvailableToSendQuestionary(item),
      }))

      const data = processed.filter((item) => {
        let toAdd = true
        if (this.filters.names !== '') {
          const name = item.names.toLowerCase()
          const lastName = item.lastnames.toLowerCase()
          const email = item.email.toLowerCase()
          const filter = this.filters.names.toLowerCase()
          if (
            !name.includes(filter) &&
            !lastName.includes(filter) &&
            !email.includes(filter)
          ) {
            toAdd = false
          }
        }
        if (this.selectedFilters.currentQuestionary.length > 0) {
          const completeness = item.currentQuestionary?.section
          this.selectedFilters.currentQuestionary.forEach((progressFilter) => {
            if (!progressFilter.value && completeness === SECTIONS.FINISH) {
              toAdd = false
            } else if (
              progressFilter.value &&
              completeness !== SECTIONS.FINISH
            ) {
              toAdd = false
            }
          })
        }
        if (this.selectedFilters.modelQuestionary.length > 0) {
          const completeness = item.modelQuestionary?.section
          this.selectedFilters.modelQuestionary.forEach((progressFilter) => {
            if (!progressFilter.value && completeness === SECTIONS.FINISH) {
              toAdd = false
            } else if (
              progressFilter.value &&
              completeness !== SECTIONS.FINISH
            ) {
              toAdd = false
            }
          })
        }
        return toAdd
      })

      const total = data.length
      const totalPending = data.filter((employee) => {
        // Si existe cuestionario activo, debe estar completo (o no se requiere)
        const activeComplete =
          !this.existsActiveQuestionary ||
          employee.currentQuestionary?.section === SECTIONS.FINISH

        // Si existe cuestionario modelo, debe estar completo (o no se requiere)
        const modelComplete =
          !this.existsModelQuestionary ||
          employee.modelQuestionary?.section === SECTIONS.FINISH

        return activeComplete && modelComplete
      }).length

      return { data, total, totalPending }
    },
  },
  created() {
    this.table.filters = this.defaultFilter
    this.table.filtersPending._where = {
      ...this.table.filtersPending._where,
      ...this.defaultFilter,
    }
  },
  methods: {
    ...mapActions({
      getEmployeesInProjectAction: 'project/getEmployeesInProject',
    }),
    onSearch() {
      this.selectedFilters.currentQuestionary = this.filters.currentQuestionary
      this.selectedFilters.modelQuestionary = this.filters.modelQuestionary
      this.onShowFilters()
    },
    onShowFilters() {
      this.showFilters = !this.showFilters
    },
    onCloseCurrentQuestionaryTag() {
      this.filters.currentQuestionary = []
      this.selectedFilters.currentQuestionary = []
    },
    onCloseModelQuestionaryTag() {
      this.filters.modelQuestionary = []
      this.selectedFilters.modelQuestionary = []
    },
    async getEmployeesInProject() {
      this.$store.commit('loading', true)
      await this.getEmployeesInProjectAction(this.$route.params.id)
      this.$store.commit('loading', false)
    },
    async onPageChange(page) {
      this.table.filters._start =
        this.table.filters._limit * page - this.table.filters._limit
      await this.getEmployeesInProject()
    },
    async updateAfterDelete() {
      await this.getEmployeesInProject()
    },
    isAvailableToSendQuestionary(row) {
      // Si existe cuestionario activo, debe estar completo para HABILITAR
      const activeComplete =
        !this.existsActiveQuestionary ||
        row.currentQuestionary?.section === SECTIONS.FINISH

      // Si existe cuestionario modelo, debe estar completo para HABILITAR
      const modelComplete =
        !this.existsModelQuestionary ||
        row.modelQuestionary?.section === SECTIONS.FINISH

      // Esta habilitado para reenviar solo si ambos cuestionarios (si existen) están completos
      return activeComplete && modelComplete
    },
  },
}
